import React from 'react';
import styles from './styles/styles.module.css';

import { useSelector } from 'react-redux';
import { AppState } from '../../Redux/store';
import RegularLogin from './components/RegularLogin';
import { Mfa } from './components/Mfa';
import FullPageLoader from '../../components/FullPageLoader/FullPageLoader';

const Login: React.FC = () => {
  const { showMfaInput } = useSelector((state: AppState) => state.auth);
  const globalLoading = useSelector(
    (state: AppState) => state.global.globalLoading
  );

  // Show loading state if global loading is undefined
  if (globalLoading === undefined || globalLoading === true) {
    return <FullPageLoader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerContainer}>
        <div className={styles.logoContainer}>
          <img
            alt="CompanyLogo"
            width={50}
            height={50}
            src="/assets/companyLogo.png"
          />
        </div>

        <div className={styles.loginWindow}>
          <p className={styles.loginHeadline}>Login to your account</p>
          <div className={styles.dividerLine} />

          {!showMfaInput ? <RegularLogin /> : <Mfa />}
        </div>
      </div>
    </div>
  );
};

export default Login;
